<div class="process-layers-table-wrapper">
  <mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="LayerId">
      <mat-header-cell mat-sort-header *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.layerId" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.LayerId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="LayerExternalId">
      <mat-header-cell mat-sort-header *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.layerExternalId" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.LayerExternalId }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="LayerName">
      <mat-header-cell mat-sort-header *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.layerName" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.LayerName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Status">
      <mat-header-cell mat-sort-header *matHeaderCellDef>
        {{ "sources.scheduling.tableOftenColumns.status" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">
        <div class="process-status">
          <mee-process-status [currentProcessStatus]="layerProcessInfo.Status"></mee-process-status>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PercentageComplete">
      <mat-header-cell mat-sort-header *matHeaderCellDef>
        {{ "sources.scheduling.tableOftenColumns.percent" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">
        <ng-container *ngIf="getIsShowProgress(layerProcessInfo)">
          {{ layerProcessInfo.PercentageComplete + "%" }}
        </ng-container>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="TotalCount">
      <mat-header-cell *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.total" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.TotalCount }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="IndexedCount">
      <mat-header-cell *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.indexed" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.IndexedCount }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="IndexationFailedCount">
      <mat-header-cell *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.indexationFailed" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.IndexationFailedCount }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="ReadAndStoredCount">
      <mat-header-cell *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.readAndStored" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.ReadAndStoredCount }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="FailedToReadAndStoreCount">
      <mat-header-cell *matHeaderCellDef>
        {{ "sources.processLayersTable.columns.failedToRead" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let layerProcessInfo">{{ layerProcessInfo.FailedToReadAndStoreCount }}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
